import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinsupamidc() {



  const cardData =
  {
    keyword: ' Cab Service in Supa MIDC',
    heading: 'Pune Corporate Cars India Private Limited: Cab Service in Supa MIDC',
    headingDescription: 'Pune Corporate Cars India Private Limited provides reliable and professional Cab Service in Supa MIDC, catering to the transportation needs of factories, industrial units, and corporate offices in the area. Our fleet of well-maintained sedans, SUVs, and premium vehicles ensures comfortable, safe, and timely travel for employees, supervisors, clients, and senior executives. Whether it is daily staff transportation, industrial visits, airport pickups, or executive business travel, we deliver punctual and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and dedicated service support, Pune Corporate Cars India Private Limited ensures a smooth and premium travel experience for businesses operating in and around Supa MIDC.',

    top: 'Top Places to Visit in Supa with Pune Corporate Car',

  "topPlaces": [
  {
    "title": "Shirdi Sai Baba Temple",
    "description": "Located around an hour from Supa, the Shirdi Sai Baba Temple is one of India’s most revered spiritual destinations. Devotees from across the country visit to seek blessings from Sai Baba, whose life and teachings emphasized love, service, and faith. The temple complex features meditation halls, daily bhajans, beautiful architecture, and a peaceful spiritual environment that immerses visitors in devotion and tranquility."
  },
  {
    "title": "Ahmednagar Fort",
    "description": "Ahmednagar Fort, situated near Supa, is a massive and historic stone fortress built in the 15th century. Once a stronghold of the Nizam Shahi dynasty and later used by the Marathas and British, the fort is famous for its strong circular bastions and moat. National leaders such as Pandit Jawaharlal Nehru were imprisoned here during the freedom struggle. Walking through its ancient walls gives visitors a deep sense of India’s political and military past."
  },
  {
    "title": "Rehekuri Blackbuck Sanctuary",
    "description": "Rehekuri Wildlife Sanctuary, located close to Supa, is a protected reserve known for its thriving population of Indian blackbucks. Spread across grasslands and dry plains, it offers a rare chance to observe these elegant antelopes in their natural habitat. Bird watchers can also spot various species of migratory and local birds. The peaceful environment and raw natural landscapes make it a perfect destination for nature enthusiasts, wildlife photographers, and weekend explorers."
  },
  {
    "title": "Meherabad",
    "description": "Meherabad, a serene ashram near Ahmednagar, is the spiritual resting place of Meher Baba, a world-renowned spiritual master. The center attracts followers and travelers from across the globe who come for meditation, silence, and spiritual learning. The ashram’s calm surroundings, museum, libraries, and living quarters provide deep insight into Meher Baba’s life and teachings, making it an inspiring and reflective experience for visitors."
  },
  {
    "title": "Shree Chincholi Vighnahar Ganapati Temple",
    "description": "Located near Supa, the Chincholi Ganapati Temple is a significant pilgrimage site dedicated to Lord Ganesha. Surrounded by rural scenery and a calm village atmosphere, the temple offers a peaceful space for worship and reflection. Festivals like Ganesh Chaturthi attract large crowds, and the temple’s traditional architecture and spiritual ambiance make it an important cultural and devotional landmark in the region."
  },
  {
    "title": "Faria Bagh Palace",
    "description": "Faria Bagh is a historical monument located near Ahmednagar, believed to be part of the old Nizam-era royal complex. Though partly in ruins, the palace still displays elegant arches, stone corridors, and architectural detailing that tell stories of its regal past. The monument is surrounded by open land, creating a photogenic atmosphere and making it a must-visit for history lovers and heritage travelers exploring the region."
  },
  {
    "title": "Salabat Khan’s Tomb (Chand Bibi Mahal)",
    "description": "Perched atop a hill with stunning views of the plains below, this three-storeyed stone monument is dedicated to Salabat Khan, a minister of the Ahmednagar Sultanate. Often mistaken for Chand Bibi’s palace, the tomb features graceful arches, stone pillars, and a unique octagonal structure. The climb to the top offers cooling winds and a breathtaking panorama, making it a favorite destination for photographers, trekkers, and history enthusiasts."
  },
  {
    "title": "Visapur Lake & Dam",
    "description": "Not far from Supa, Visapur Lake and Dam provide a peaceful escape surrounded by natural beauty. The reservoir is a popular spot for picnics, evening walks, and casual weekend outings. During monsoon, the lush greenery, misty surroundings, and water overflow create a refreshing scenic environment. It’s a great place to relax with family, enjoy calm waterfront views, or simply watch a beautiful sunset."
  }
],


 "services": [
    {
      "name": "Supa MIDC Employee Cab",
      "description": "Supa MIDC Employee Cab provides reliable daily cab services for employees working in Supa MIDC, ensuring punctual and safe commute operations."
    },
    {
      "name": "Industrial Cab Supa",
      "description": "Industrial Cab Supa offers structured cab transportation for factories and industrial units, ensuring timely workforce mobility across shifts."
    },
    {
      "name": "Worker Transport Supa",
      "description": "Worker Transport Supa delivers dependable pickup–drop solutions for industrial and factory workers, ensuring smooth and safe daily travel."
    },
    {
      "name": "Company Staff Shuttle Supa",
      "description": "Company Staff Shuttle Supa provides well-managed shuttle services for corporate staff and employees working in and around Supa MIDC."
    },
    {
      "name": "Affordable Cab Supa MIDC",
      "description": "Affordable Cab Supa MIDC offers cost-effective cab services for office travel, daily commute, and industrial transportation needs."
    },
    {
      "name": "Monthly Cab Hire Supa",
      "description": "Monthly Cab Hire Supa provides long-term cab rental packages for companies requiring consistent employee transportation services."
    },
    {
      "name": "Business Taxi Supa",
      "description": "Business Taxi Supa offers professional taxi services for corporate travel, executive visits, and local business transportation needs."
    },
    {
      "name": "Staff Commute Supa MIDC",
      "description": "Staff Commute Supa MIDC ensures organized employee transportation with reliable routing, timely pickups, and trained drivers."
    },
    {
      "name": "Outstation Cab Supa",
      "description": "Outstation Cab Supa provides safe and comfortable long-distance travel solutions for business trips and intercity transportation from Supa."
    },
    {
      "name": "Sedan Cab Supa",
      "description": "Sedan Cab Supa offers premium sedan vehicles ideal for executives, managers, and corporate visitors traveling within Supa MIDC."
    },
    {
      "name": "SUV Cab Supa",
      "description": "SUV Cab Supa provides spacious and comfortable SUVs suitable for team travel, industrial visits, and long-distance corporate trips."
    },
    {
      "name": "Best Corporate Cab Supa",
      "description": "Best Corporate Cab Supa delivers top-quality corporate travel services featuring trained drivers, clean vehicles, and punctual operations."
    },
    {
      "name": "Corporate Fleet Supa MIDC",
      "description": "Corporate Fleet Supa MIDC offers dedicated fleet solutions including staff cabs, sedans, and SUVs for corporate and industrial mobility."
    },
    {
      "name": "Factory Worker Pickup Supa",
      "description": "Factory Worker Pickup Supa specializes in shift-based pickup and drop services for factory workers, ensuring safe and timely transport."
    },
    {
      "name": "Employee Shuttle Supa",
      "description": "Employee Shuttle Supa provides shuttle vans and minibuses for bulk staff transportation, ideal for factories and corporate units."
    }
  ],

  "tableData": [
    ["Supa MIDC Employee Cab", "Industrial Cab Supa"],
    ["Worker Transport Supa", "Company Staff Shuttle Supa"],
    ["Affordable Cab Supa MIDC", "Monthly Cab Hire Supa"],
    ["Business Taxi Supa", "Staff Commute Supa MIDC"],
    ["Outstation Cab Supa", "Sedan Cab Supa"],
    ["SUV Cab Supa", "Best Corporate Cab Supa"],
    ["Corporate Fleet Supa MIDC", "Factory Worker Pickup Supa"],
    ["Employee Shuttle Supa", ""]
  ],


  






"whychoose": [
  {
    "WhyChooseheading": "Cab Service in Supa MIDC",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable and efficient cab services for employees and executives commuting to Supa MIDC, ensuring seamless corporate travel."
  },
  {
    "WhyChooseheading": "Punctual Pickups & Drop-offs",
    "WhyChoosedescription": "We guarantee on-time pickups and drops, helping corporate staff reach their workplaces in Supa MIDC without delays."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained and courteous chauffeurs ensure safe, disciplined, and comfortable travel for employees and executives."
  },
  {
    "WhyChooseheading": "Well-Maintained Fleet of Vehicles",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, safe, and comfortable for daily industrial commuting."
  },
  {
    "WhyChooseheading": "Tailored Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible cab rental plans customized to meet the commuting requirements of businesses and employees in Supa MIDC."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Assistance",
    "WhyChoosedescription": "Our team provides round-the-clock support for scheduling, emergencies, and route adjustments, ensuring uninterrupted travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Travel Experience",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, offering secure and clean rides for corporate clients."
  },
  {
    "WhyChooseheading": "Easy Booking & Smooth Coordination",
    "WhyChoosedescription": "Corporate travel is managed effortlessly through our efficient booking process and reliable coordination, making employee transport hassle-free."
  }
]





























  }

const faqData = [
  {
    question: 'Do you provide cab services in Supa MIDC?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and efficient cab services for industries, employees, and corporate offices in Supa MIDC.',
  },
  {
    question: 'What types of cab services are available in Supa MIDC?',
    answer: 'We provide employee transportation, corporate cab services, point-to-point pickups and drops, and dedicated shift-based transport solutions.',
  },
  {
    question: 'Do you offer daily pickup and drop services for Supa MIDC employees?',
    answer: 'Yes, we provide daily employee commuting solutions with customized routes and shift-based schedules.',
  },
  {
    question: 'How can companies book cab services for Supa MIDC?',
    answer: 'Bookings can be made via our website, mobile app, or through our 24×7 dedicated corporate support team.',
  },
  {
    question: 'What vehicle options are available for Supa MIDC cab services?',
    answer: 'We offer hatchbacks, sedans, SUVs, tempo travellers, and mini-buses depending on company requirements and employee strength.',
  },
  {
    question: 'Can companies opt for long-term cab service contracts in Supa MIDC?',
    answer: 'Yes, we offer flexible monthly, quarterly, and annual corporate cab contracts for businesses in Supa MIDC.',
  },
  {
    question: 'Are safety and tracking features included in Supa MIDC cab services?',
    answer: 'All our vehicles are GPS-enabled, sanitized regularly, and driven by trained and verified chauffeurs to ensure employee safety.',
  },
  {
    question: 'Do you support multiple shift timings for MIDC transport?',
    answer: 'Yes, we manage transportation for multiple shift schedules, including night shifts and rotational timing.',
  },
  {
    question: 'What payment options are available for Supa MIDC cab services?',
    answer: 'We offer UPI, credit/debit cards, bank transfers, digital wallets, and monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Kunal Deshmukh',
    feedback: 'Reliable cab service for our Supa MIDC plant. The punctuality and driver professionalism are excellent.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Prachi Gawande',
    feedback: 'Pune Corporate Cars India Private Limited has made our employee transportation smooth and hassle-free. Very dependable service.',
    rating: 5,
  },
];



















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Supa MIDC",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cabs-supa.jpg", // replace with actual image URL
  "description": "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Supa MIDC, Pune, including employee shuttles, industrial transport, staff pickup and drop, office commute, and business travel cabs. Chauffeur-driven sedans, SUVs, and outstation cabs ensure safe and timely transport for companies and industrial units.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // update if needed
    "ratingCount": "4400", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/cab-service-supa-midc"
  }
};





  return (
    <div>
<Helmet>
  <title>Cab Service in Supa MIDC | Employee & Industrial Cabs | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Pune Corporate Cars India Private Limited provides reliable corporate cab services in Supa MIDC, Pune, including employee shuttles, industrial transport, staff pickup and drop, office commute, and business travel cabs. Chauffeur-driven sedans, SUVs, and outstation cabs ensure safe and timely transport for companies and industrial units."
  />

  <meta
    name="keywords"
    content="Supa MIDC Employee Cab, Industrial Cab Supa, Worker Transport Supa, Company Staff Shuttle Supa, Affordable Cab Supa MIDC, Monthly Cab Hire Supa, Business Taxi Supa, Staff Commute Supa MIDC, Outstation Cab Supa, Sedan Cab Supa, SUV Cab Supa, Best Corporate Cab Supa, Corporate Fleet Supa MIDC, Factory Worker Pickup Supa, Employee Shuttle Supa"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/28.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinsupamidc;